<template>
  <div class="card">
    <div :class="['card-header', headerColor]"></div>
    <div class="card-content">
      <p class="small-text">{{ status }}</p>
      <p class="big-text"> {{ deveExibirDados ? `${quantidadeDeSolicitacoes} solicitações` : '\u00A0' }} </p>
      <p class="value">{{ valor }}</p>
      <p class="percentage">{{ porcentagem }}% do valor total</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headerColor: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    quantidadeDeSolicitacoes: {
      type: Number,
      default: 0
    },
    valor: {
      type: String,
      default: ''
    },
    porcentagem: {
      type: Number,
      default: 0
    }
  }, computed: {
    deveExibirDados() {
      return this.quantidadeDeSolicitacoes !== 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashCard.vue?2d849b32